module.exports = __webpack_public_path__ + "7532a7c3cd750de112c02a49e96d86f8.pdf";